import state from './moduleReportsState.js'
import mutations from './moduleReportsMutations.js'
import actions from './moduleReportsActions.js'
import getters from './moduleReportsGetters.js'

import co2 from "./onlineCo2/moduleOnlineCo2"

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    co2
  }
}


